/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {OfferProduct} from 'compob2b-libs';

export abstract class MarkupValueStrategy {
  abstract apply(price: number, value: number): number;

  applyAll(products: OfferProduct[], value: number): Map<number, number> {
    const map = new Map<number, number>();
    const sum = products.reduce((n, {price, cartProduct}) => n + price * cartProduct.amount, 0);

    products.forEach(item => {
      const p = (sum === 0 || item.cartProduct.amount === 0) ? 0 :
        (value * item.price * item.cartProduct.amount / sum) / item.cartProduct.amount;

      map.set(item.cartProduct.id, this.apply(item.price, p));
    });

    return map;
  }
}
